import { useMutation, type UseMutationOptions, type UseMutationResult } from '@tanstack/react-query';
import { useLoadingStore } from '../stores/loadingStore';

type BlockingMutationOptions<TData, TError, TVariables, TOnMutateResult> =
  UseMutationOptions<TData, TError, TVariables, TOnMutateResult> & {
    loadingMessage?: string;
  };

export function useBlockingMutation<
  TData = unknown,
  TError = Error,
  TVariables = void,
  TOnMutateResult = unknown,
>(
  options: BlockingMutationOptions<TData, TError, TVariables, TOnMutateResult>,
): UseMutationResult<TData, TError, TVariables, TOnMutateResult> {
  const { loadingMessage, onMutate, onSettled, ...rest } = options;

  return useMutation({
    ...rest,
    onMutate: async (...args) => {
      useLoadingStore.getState().show(loadingMessage);
      if (onMutate) {
        return onMutate(...args);
      }
      return undefined as TOnMutateResult;
    },
    onSettled: (...args) => {
      useLoadingStore.getState().hide();
      if (onSettled) {
        onSettled(...args);
      }
    },
  });
}
